import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import TopNavbar from '../components/Navbar/TopNavbar/TopNavbar';
import SummerCampaignBar from '../components/SummerCampaign/SummerCampaignBar';
import SummerCampaignModal from '../components/SummerCampaign/SummerCampaignModal';
import Home from '../pages/Home';

const About = lazy(() => import('../pages/About'));
const Services = lazy(() => import('../pages/Services'));
const Contact = lazy(() => import('../pages/Contact'));
const Location = lazy(() => import('../pages/Location'));
const NotFound = lazy(() => import('../pages/NotFound'));
const KlimaBakimi = lazy(() => import('../pages/KlimaBakimi'));
const OdaTermostati = lazy(() => import('../pages/OdaTermostati'));

const PageLoader = () => (
  <div style={{ padding: '3rem', textAlign: 'center', color: '#0A5F84' }}>
    Yükleniyor...
  </div>
);

const Routers = () => {
  return (
    <HelmetProvider>
      <Router>
        <TopNavbar />
        <SummerCampaignBar />
        <Navbar />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="anasayfa" element={<Home />} />
            <Route path="hakkımızda" element={<About />} />
            <Route path="hakkimizda" element={<About />} />
            <Route path="servislerimiz" element={<Services />} />
            <Route path="servislerimiz/klima-bakimi" element={<KlimaBakimi />} />
            <Route path="servislerimiz/oda-termostati" element={<OdaTermostati />} />
            <Route path="iletişim" element={<Contact />} />
            <Route path="iletisim" element={<Contact />} />
            <Route path="konum" element={<Location />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
        <SummerCampaignModal />
      </Router>
    </HelmetProvider>
  );
};

export default Routers;
